export default {"src":"/_next/static/media/fusion_cat_ic.88168369.svg","height":120,"width":120};